var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"color":_vm.color,"rotate":-90,"size":_vm.size,"value":_vm.totalRatio,"width":8}},[_c('span',[_vm._v(" "+_vm._s(_vm.totalRatio)+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }